import { KnowledgeUnit } from '../../types'

export interface CoverageResult {
  totalStandards: number
  standardsWithKUs: number
  coverageRate: number
  kuCountByStandard: Record<string, number>
}

export function coverageRate(kus: KnowledgeUnit[], standardIds: string[]): CoverageResult {
  const kuCountByStandard: Record<string, number> = {}
  for (const ku of kus) {
    kuCountByStandard[ku.standard_id] = (kuCountByStandard[ku.standard_id] || 0) + 1
  }
  const standardsWithKUs = standardIds.filter((s) => (kuCountByStandard[s] || 0) > 0).length
  return {
    totalStandards: standardIds.length,
    standardsWithKUs,
    coverageRate: standardIds.length > 0 ? standardsWithKUs / standardIds.length : 0,
    kuCountByStandard,
  }
}
